<template>
  <v-container fluid class="container_bg">

    <v-btn fab x-small icon color="white" style="background:#4e6ef7;z-index:9000"
        fixed right @click="drawer = !drawer"
        >
        <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-row>
      <v-navigation-drawer
        v-model="drawer"
        color="#ffffff" 
        right
        fixed
        style="z-index:5000"
        >
      <v-list
        nav
        dense
        >
        <v-list-item-group
          active-class="deep-purple--text text--accent-4"
          >
          <v-list-item class="pa-0">
            <v-btn width="100%" text elevation="0" @click="nav('apiCommon')"><div style="width:100%;text-align:left">{{this.$i18n.locale == 'ko' ? '공통' : 'Common'}}</div></v-btn>
          </v-list-item>

          <v-list-item class="pa-0">
            <v-btn width="100%" text @click="nav('apiVisitorInsert')"><div style="width:100%;text-align:left">{{this.$i18n.locale == 'ko' ? '참가자등록' : 'Visitor registration'}}</div></v-btn>
          </v-list-item>

          <v-list-item class="pa-0">
            <v-btn width="100%" text @click="nav('apiVisitorUpdate')"><div style="width:100%;text-align:left">{{this.$i18n.locale == 'ko' ? '참가자수정' : 'Visitor Edit'}}</div></v-btn>
          </v-list-item>

          <v-list-item class="pa-0">
            <v-btn width="100%" text @click="nav('apiVisitorDelete')"><div style="width:100%;text-align:left">{{this.$i18n.locale == 'ko' ? '참가자삭제' : 'Visitor Delete'}}</div></v-btn>
          </v-list-item>

        </v-list-item-group>
      </v-list>
      </v-navigation-drawer>
    <router-view />
    </v-row>


    
  </v-container>
</template>
<script>

export default {

    mounted() {

    },

    data: () => ({
      drawer: true
    }),

    methods: {

      nav(name){
        //console.log("nav....");
        this.$router.push("/ApiDoc/"+name).catch((error)=>{
            console.log("error : "+error);
        });
      }

    },

    created(){

    }


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>